import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface DateRangeFilterProps {
  idPrefix: string;
  from: string;
  to: string;
  onFromChange: (value: string) => void;
  onToChange: (value: string) => void;
  /** Shown when any filter (date or search) is active. */
  onClear?: () => void;
  hasFilters?: boolean;
}

/** From / To date inputs with an optional "Clear filters" button. Values are YYYY-MM-DD strings. */
const DateRangeFilter = ({ idPrefix, from, to, onFromChange, onToChange, onClear, hasFilters }: DateRangeFilterProps) => (
  <div className="flex flex-wrap items-end gap-3">
    <div className="space-y-1">
      <Label htmlFor={`${idPrefix}-from`} className="text-xs text-muted-foreground">From</Label>
      <Input
        id={`${idPrefix}-from`}
        type="date"
        value={from}
        max={to || undefined}
        onChange={(e) => onFromChange(e.target.value)}
        className="h-9 w-[150px]"
      />
    </div>
    <div className="space-y-1">
      <Label htmlFor={`${idPrefix}-to`} className="text-xs text-muted-foreground">To</Label>
      <Input
        id={`${idPrefix}-to`}
        type="date"
        value={to}
        min={from || undefined}
        onChange={(e) => onToChange(e.target.value)}
        className="h-9 w-[150px]"
      />
    </div>
    {hasFilters && onClear && (
      <Button variant="ghost" size="sm" className="h-9 gap-1.5 text-muted-foreground" onClick={onClear}>
        <X className="h-3.5 w-3.5" /> Clear filters
      </Button>
    )}
  </div>
);

export default DateRangeFilter;
